export default "__VITE_ASSET__ppK3e7fb__"